// @ts-expect-error untyped module
import { FeedbackLoaderProvider } from 'feedback-loader/FeedbackLoaderProvider';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { AppProvider } from 'foundations-components/components/AppProvider';
import WindowDimensionsProvider from 'marketplace-ui-common/components/providers/WindowDimensionsProvider';
import HSAnalyticsProvider from 'marketplace-ui-common/tracking/components/HSAnalyticsProvider';
import { UsageTrackerProvider } from 'marketplace-ui-tracking';
import { useEffect, useMemo } from 'react';
import { Routes } from '../components/Routes';
import { AppContextProvider } from '../context/AppContext';
import { AuthProvider } from '../context/AuthContext';
import { LocationHistoryProvider } from '../context/LocationHistoryContext';
import { getWindowLocation } from '../utils/urls';
import { createStandaloneTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
function getReferrerUrlParam() {
  return new URLSearchParams(getWindowLocation().search).get('referrer') || undefined;
}
const dataFetchingClient = new DataFetchingClient();
export function BaseApp({
  appContext,
  auth = {},
  history
}) {
  const referrer = getReferrerUrlParam();
  useEffect(() => {
    setDocumentTitle('marketplaceStorefront.htmlTitle');
    if (appContext === 'app') {
      const scrollContainer = document.querySelector('.quartz-grid-app-container');
      if (scrollContainer) scrollContainer.style.scrollbarGutter = 'stable';
    }
  }, [appContext]);
  const standaloneTracker = useMemo(() => createStandaloneTracker({
    appContext,
    history,
    referrer
  }), [appContext, history, referrer]);
  const inner = /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dataFetchingClient,
    children: /*#__PURE__*/_jsx(HSAnalyticsProvider, {
      children: /*#__PURE__*/_jsx(CopilotProvider, {
        children: /*#__PURE__*/_jsx(WindowDimensionsProvider, {
          children: /*#__PURE__*/_jsx(AppContextProvider, {
            value: appContext,
            children: /*#__PURE__*/_jsx(AuthProvider, {
              value: auth,
              children: /*#__PURE__*/_jsx(UsageTrackerProvider, {
                tracker: standaloneTracker,
                children: /*#__PURE__*/_jsx(AppProvider, {
                  children: /*#__PURE__*/_jsx(LocationHistoryProvider, {
                    children: /*#__PURE__*/_jsx(Routes, {
                      referrer: referrer
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
  if (appContext === 'app') {
    return /*#__PURE__*/_jsx(FeedbackLoaderProvider, {
      children: inner
    });
  }
  return inner;
}